/**
 * MusicLayout - /music 配下の共通レイアウト
 *
 * ミニプレイヤーを1箇所で描画し、音声エンジンの寿命をこのレイアウトのマウント期間に揃える。
 * 音楽画面から離れたらエンジンごと破棄されるので、他の画面で勝手に鳴ることはない。
 */

import { useEffect } from 'react'
import { Outlet } from 'react-router'

import { disposeMusicPlayback, initMusicPlayback } from '@/lib/music-playback'

import { MiniPlayer } from './mini-player'

export const MusicLayout = () => {
  useEffect(() => {
    initMusicPlayback()
    return disposeMusicPlayback
  }, [])

  return (
    <div className="flex h-full flex-col bg-background">
      <Outlet />
      <MiniPlayer />
    </div>
  )
}
